import Trans from 'next-translate/Trans'
import React from 'react'
import CompanyInfoHoverCard from 'tennders-transactions/components/CompanyInfoHoverCard'
import useSession from 'tennders-auth/hooks/useSession'
import GHref from 'tennders-market/common/components/element/GHref'
import { copyToClipboard } from 'tennders-stracture/libs/utils'
import RequiresPermission from 'tennders-auth/components/RequiresPermission'
import { COMPANY_DIR_LIST_VIEW } from 'tennders-stracture/libs/permissions'
import dynamic from 'next/dynamic'
import { useToast } from 'tennders-common/hooks/useToast'
import useTranslation from 'next-translate/useTranslation'
import IconCopy from '../../../../icons/icon-copy.svg'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

const Company = ({ company, branch, createdBy, documentType }) => {
  const { user } = useSession()
  const { toastSuccess } = useToast()
  const { t } = useTranslation()

  const fallBack = (
    <span>
      {company?.name}
    </span>
  )

  return (
    <div className="ml-8 text-14 w-80">
      <div className="tennders-open-company-info">
        <strong className="d-flex align-center">
          {' '}
          {company?.id === user?.company?.id ? (
            <div className="mb-10">
              <u>
                <Trans i18nKey="transaction:yourCompany" />
              </u>
              {branch?.id ? (
                <GHref target="_blank" href={`/company-detail/${branch?.id}`}>
                  [{branch?.name}]
                </GHref>
              ) : null}
            </div>
          ) : (
            <>
              <RequiresPermission fallbackComponent={fallBack} requiredPermissions={COMPANY_DIR_LIST_VIEW}>
                <GHref href={`/company-detail/${company?.id}`} className="btn-link">
                  {company?.name}
                </GHref>
              </RequiresPermission>
              {branch?.id ? (
                <GHref target="_blank">
                  [{branch?.name}]
                </GHref>
              ) : null}
              <GHref
                onClick={() => {
                  copyToClipboard(company?.name)
                  toastSuccess(t('common:copied'))
                }}
              >
                <IconCopy className="icon-small" />
              </GHref>
            </>
          )}
        </strong>
        <div className="mb-10 conform-email">
          <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>{createdBy?.email}</EllipsisToolTip>
        </div>
        <CompanyInfoHoverCard type={documentType} company={company} />
      </div>
      <strong />
    </div>
  )
}

export default Company
